import React from "react";
import VenueCoverPhoto from "./VenueCoverPhoto";
import { useVenue } from "../api/helpers";
import { useKeynotes } from "../api/selectors";
import Line from "../common/Line";
import KeynoteRow from "../schedule/KeynoteRow";
import Schedule from "../schedule/Schedule";
import SponsorBlock from "../sponsors/SponsorBlock";
import LightTheme from "../theme/LightTheme";

const Home = () => {
  const venue = useVenue();
  const keynotes = useKeynotes();

  return (
    <div id="home" className="container">
      <VenueCoverPhoto />
      <div className="aboutBLock">
        <div className="showMoreContainer">
          <p>{venue?.summary}</p>
        </div>
        <Line />
        {keynotes?.map((item) => (
          <KeynoteRow key={item.sessionId} session={item} />
        ))}
      </div>
      <Schedule />
      <SponsorBlock />
      <style jsx>
        {`
          p {
            white-space: pre-line;
          }
          .aboutBLock {
            display: flex;
            flex-direction: column;
            padding: 13px ${LightTheme.mainContentPadding}px 39px
              ${LightTheme.mainContentPadding}px;
          }
          .container {
            display: flex;
            flex-direction: column;
            background: #fdfefe;
          }
          .showMoreContainer {
            padding: 0 0 5px 0;
          }
        `}
      </style>
    </div>
  );
};

export default Home;
